import React from 'react';
import ReactDOM from 'react-dom';
import AutoLogout from 'cccisd-autologout';

import Header from './components/Header';
import Footer from './components/Footer';

import '../styles/wordpress.scss';

const headerNode = document.getElementById('cccisd-header');
if (headerNode) {
    ReactDOM.render(
        <>
            <AutoLogout />
            <Header />
        </>,
        headerNode
    );
}

const footerNode = document.getElementById('cccisd-footer');
if (footerNode) {
    ReactDOM.render(<Footer />, footerNode);
}
